import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CoachingConfirmationModalComponent } from '../coaching-confirmation-modal/coaching-confirmation-modal.component';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';

@Component({
  selector: 'app-coaching-selection-modal',
  templateUrl: './coaching-selection-modal.component.html',
  styleUrls: ['./coaching-selection-modal.component.scss'],
})
export class CoachingSelectionModalComponent implements OnInit {
  public selectedOption: string;

  constructor(
    public dialogRef: MatDialogRef<CoachingSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public dataService: DataService,
    public accessService: AccessService,
    public dialog: MatDialog,
    private mixpanelService: MixPanelService
  ) {}

  ngOnInit(): void {
    this.selectedOption = this.data.enableSelfCoaching ? 'self' : 'inPerson';

    this.dialogRef.backdropClick().subscribe(() => {
      this.mixpanelService.track('modal-closed/configurations-page/coaching-page/switch-mode-modal/tap-outside-backdrop');
    });
  }

  trackActiveClick() {
    this.mixpanelService.track('dead-clicked/configurations-page/coaching-page/switch-mode-modal/active-status', {
      ActiveMode: this.selectedOption,
    });
  }

  saveSelection() {
    this.mixpanelService.track('button-clicked/configurations-page/coaching-page/switch-mode-modal/enable', {
      EnableSelfCoaching: !this.data.enableSelfCoaching,
    });

    const dialogRef = this.dialog.open(CoachingConfirmationModalComponent, {
      panelClass: ['coaching-confirmation-modal', 'mobile-modal'],
      autoFocus: false,
      disableClose: false,
      data: {
        enableSelfCoaching: this.data.enableSelfCoaching,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined) return;
      if (result != this.data.enableSelfCoaching) {
        this.dialogRef.close(result);
      }
    });
  }

  cancelSelection() {
    this.mixpanelService.track('button-clicked/configurations-page/coaching-page/switch-mode-modal/close-button');
    this.dialogRef.close(undefined);
  }
}
